import { Component, TemplateRef, ViewChild } from "@angular/core";
import { Router, RouterLink, RouterLinkActive } from "@angular/router";
import { AuthService } from "../../core/services/auth.service";
import { interval } from "rxjs";
import { permissionType } from "src/app/models/enums";
import { UserIdleService } from "wspowerpack";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "src/environments/environment";
import { NgIf } from "@angular/common";
import { AccountClient, AccountV1Model } from "src/app/api/client";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
  standalone: true,
  imports: [RouterLink, RouterLinkActive, NgIf],
})
export class NavbarComponent {
  @ViewChild("timeout", { static: true }) timeoutDialog!: TemplateRef<any>;
  title = "Material Certification";
  showMobileMenu: boolean = false;
  dialogRef: NgbModalRef | null = null;
  count: number = 30;
  isA: boolean = false;
  isAccountManager: boolean = false;
  isAdmin: boolean = false;
  welcome: string | null | undefined = null;
  currentAccount: AccountV1Model = new AccountV1Model();
  isLoading: boolean = true;
  apiRoot: string = environment.apiRoot;
  currentAccountName: string | null = null;
  guid: string | null | undefined = "act";
  enableTimesheets: boolean = false;
  enableRequestOff: boolean = false;
  employeeTag: string | null = null;
  employeeRoute: string = "staff";
  clientTag: string | null = null;
  constructor(
    private userIdle: UserIdleService,
    private router: Router,
    private authService: AuthService,
    //private userIdle: UserIdleService,
    private modalService: NgbModal,
    private accountClient: AccountClient
  ) {}

  // helper function to determine if the active class should be added to the administration dropdown link
  addActiveClassToAdminDropdown(): boolean {
    let url = this.router.url;
    //if it has administration in it return true
    if (url.indexOf("admin") != -1) {
      return true;
    } else {
      //otherwise return false to not add active class
      return false;
    }
  }

  ngOnInit(): void {
    this.welcome = this.authService.getUserDisplayName();
    this.isAccountManager = this.authService.hasPermission(
      permissionType.AccountManager
    );
    this.isAdmin = this.authService.hasPermission(permissionType.AccountAdmin);

    this.authService.currentAccountName$.subscribe((value) => {
      this.currentAccountName = this.authService.getCurrentAccountName();
      this.loadCurrentAccount();
    });

    this.authService.isLoggedIn$.subscribe((l) => {
      this.isA = l;

      this.welcome = this.authService.getUserDisplayName();
      this.isAccountManager = this.authService.hasPermission(
        permissionType.AccountManager
      );
      if (l) {
        this.setIdle();
        this.guid =
          this.authService.getCurrentContext()?.context?.user?.currentAccountCode;

        this.accountClient
          .getById(this.authService.user?.currentAccountId!)
          .subscribe((data) => {
            this.enableRequestOff = data.enableRequestOff;
            this.enableTimesheets = data.enableTimesheets;
            this.employeeTag = data.employeeTag;
            this.clientTag = data.clientTag;
            if (data.employeeTag.toLowerCase() == "provider") {
              this.employeeRoute = "providers";
            } else if (data.employeeTag.toLowerCase() == "employee") {
              this.employeeRoute = "employees";
            }
          });
      } else {
        this.stop();
        this.stopWatching();
      }
    });

    if (this.authService.isLoggedIn()) {
      this.setIdle();
      this.guid =
        this.authService.getCurrentContext()?.context?.user?.currentAccountCode;

      this.accountClient
        .getById(this.authService.user?.currentAccountId!)
        .subscribe((data) => {
          this.enableRequestOff = data.enableRequestOff;
          this.enableTimesheets = data.enableTimesheets;
          this.employeeTag = data.employeeTag;
          this.clientTag = data.clientTag;
          if (data.employeeTag.toLowerCase() == "provider") {
            this.employeeRoute = "providers";
          } else if (data.employeeTag.toLowerCase() == "employee") {
            this.employeeRoute = "employees";
          }
        });
    }

    //this.authService.renew(); //renew on first refresh and then every 10 minutes
    interval(300000).subscribe(() => {
      this.authService.renew();
    });
  }

  onSignout(): void {
    this.authService.logout();
  }

  onShowMobileMenu(): void {
    this.showMobileMenu = !this.showMobileMenu;
  }

  setIdle(): any {
    console.log("Setup Idle");
    //Start watching for user inactivity.
    this.userIdle.startWatching();
    this.userIdle.resetTimer();
    //Start watching when user idle is starting.
    console.log(this.userIdle);
    this.userIdle.onTimerStart().subscribe((count) => {
      this.count = 30 - count;
      console.log("Idle Start! " + count);
      if (this.dialogRef == null && count != null && count < 30) {
        this.dialogRef = this.modalService.open(this.timeoutDialog, {
          backdrop: "static",
        });
      }
      if (count == 30) {
        if (this.dialogRef != null) this.dialogRef.close("");
      }
    });
    // dialogRef.afterClosed().subscribe(result => {
    //  this.setupLogDS();
    // });

    //Start watch when time is up.
    this.userIdle.onTimeout().subscribe(() => {
      console.log("Time is up!");
      if (this.dialogRef != null) this.dialogRef.close("");
      this.authService.logout();
      this.stop();
      this.stopWatching();
      this.dialogRef = null;
    });

    //Ping
    this.userIdle.ping$.subscribe(() => {
      console.log("Idle! " + new Date());
      //if (this.authService.isLoggedIn()) {
      //  this.authService.renew();
      //}
    });
  }

  stop() {
    //this.userIdle.stopTimer();
    this.userIdle.stopTimer();
  }

  stopWatching() {
    //this.userIdle.stopWatching();
    this.userIdle.stopWatching();
  }

  startWatching() {
    console.log("startWatching");
    //this.userIdle.startWatching();
    this.userIdle.startWatching();
  }

  restart() {
    //this.userIdle.resetTimer();
    this.userIdle.resetTimer();
  }

  onContinue() {
    this.dialogRef?.close("");
    this.restart();
    this.startWatching();
    this.dialogRef = null;
  }

  onManualLogout() {
    this.dialogRef?.close();
    this.authService.logout();
    this.stop();
    this.stopWatching();
    this.dialogRef = null;
  }

  loadCurrentAccount(): void {
    this.accountClient
      .getById(this.authService.user?.currentAccountId!)
      .subscribe((data) => {
        this.currentAccount = data;
        this.isLoading = false;
      });
  }
}
